export default {"src":"/_next/static/media/sequencing.bd12d247.svg","height":40,"width":40};